import { enEnviroment } from 'types/enums';

export const ENV: enEnviroment = import.meta.env.VITE_ENV;
export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
export const PAGINATION_OPTION_PER_PAGE = [10, 20, 30, 40];

// Accounts
export const ACCOUNTS_PARTNER = import.meta.env.VITE_ACCOUNTS_PARTNER;
export const ACCOUNTS_ENV = import.meta.env.VITE_ACCOUNTS_ENV;

// Analytics
export const GTAG_ID = import.meta.env.VITE_GTAG_ID;

// Branch
export const BRANCH_NAME = String(import.meta.env.VITE_APP_BRANCH_NAME) || '';
export const BRANCH_VERSION = String(import.meta.env.VITE_APP_BUILD_VERSION) || '';
export const BRANCH_DATE = String(import.meta.env.VITE_APP_BUILD_DATE) || '';
export const BRANCH_NUMBER = String(import.meta.env.VITE_APP_BUILD_NUMBER) || '';

// CDN
export const CDN_BASE_EDUZZ_URL = import.meta.env.VITE_CDN_BASE_EDUZZ_URL || 'https://cdn.eduzzcdn.com';
export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL || `${CDN_BASE_EDUZZ_URL}/sun/admin`;
export const ERROR_IMAGE = `${CDN_BASE_URL}/default-product-img.svg`;

// Old Admin
export const URL_OLD_ADMIN = String(import.meta.env.VITE_URL_OLD_ADMIN) || 'https://adminsun.test.devzz.ninja';

// Sentry
export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS || '';
export const SENTRY_AUTH_TOKEN =
  import.meta.env.VITE_SENTRY_AUTH_TOKEN || 'd03bc28c53c24b84993fbeab62994e1a837f50402d924c26a154c5036d23a05b';

//HOTJAR
export const HOTJAR_ID = import.meta.env.VITE_HOTJAT_ID || 3006539;
export const HOTJAR_SNIPPET_VERSION = import.meta.env.VITE_HOTJAR_SNIPPET_VERSION || 6;
